import { Grid, IconButton, Tooltip, TextField, Button, Box } from "@material-ui/core"
import HeaderModal from "../../../global/headerModal"
import ModalBase from "./../../../global/ModalBase"
import { makeStyles } from "@material-ui/core"
import { useDispatch } from "react-redux"
import { obtenerClientesCotizadorAction, aceptarCotizacionAction } from "../../../ducks/cotizadorDuck"
import { useState } from "react"
import BeenhereIcon from '@material-ui/icons/Beenhere'
import UploadInput from "../../../global/UploadInput"
import { getBase64 } from "../../../utils/fileBase64"
import { ToastMessage } from "../../../global/ToastMessage"
import { DialogMessage } from "../../../global/DialogMessage"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
export const ModalFormAceptarCotizacionStyle = makeStyles((theme) => ({
    containerSpacing: {
        margin: "10px 5px",
        padding: "10px 10px"
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        maxWidth: "600px",
        margin: "0 auto",
        padding: theme.spacing(1),
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: 'none',
        boxShadow: theme.shadows[10],
        padding: theme.spacing(1, 2, 1),
        minWidth: "90%",
    },
}))
async function procesarArchivos(fileReverso) {
    let reverso
    for (const archivo of fileReverso) {
        const fileConvert = await getBase64(archivo).then((result) => {
            const file = String(result).split(",")[1];
            const extencion = archivo.name.split(".").pop()
            return { file, extencion };
        })
        reverso = fileConvert
    }
    return reverso
}
export const ModalFormAceptarCotizacion = ({ idCotizacion }) => {
    const [open, setOpen] = useState(false)
    const [fileFrente, setFileFrente] = useState([])
    const [fileReverso, setFileReverso] = useState([])
    const [nombreBeneficiario, setNombreBeneficiario] = useState('No aplica')
    const dispatch = useDispatch()
    const classes = ModalFormAceptarCotizacionStyle()
    const handleChange = (e) => {
        setNombreBeneficiario(e.target.value)
    }
    const handleSubmit = (e) => {
        e.preventDefault()
        if (fileFrente.length <= 0) {
            ToastMessage.fire({
                icon: "warning",
                title: "Selecciona una imagen, frente INE",
            })
            return
        }
        if (fileReverso.length <= 0) {
            ToastMessage.fire({
                icon: "warning",
                title: "Selecciona una imagen, reverso INE",
            })
            return
        }
        DialogMessage.fire({
            title: `¿Estas seguro de aceptar la cotizacion con numero: #${idCotizacion}?`,
            text: "Este cambio no se puede deshacer",
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then(async (result) => {
            if (result.isConfirmed) {
                const frente = await procesarArchivos(fileFrente)
                const reverso = await procesarArchivos(fileReverso)
                dispatch(onLoadAnction({ message: "Procesando" }))
                dispatch(aceptarCotizacionAction({
                    IdCotizacion: idCotizacion,
                    beneficiario: nombreBeneficiario,
                    imgIneFrontal: frente.file,
                    extensionFrontal: frente.extencion,
                    imgIneReverso: reverso.file,
                    extensionReverso: reverso.extencion,
                })).then((Response) => {
                    dispatch(offLoadAction())
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha ocurrido un error, por favor inténtelo de nuevo más tarde",
                        })
                        return null
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: Response.Message,
                        })
                        return null
                    }
                    handleClose()
                    dispatch(obtenerClientesCotizadorAction())
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    })
                })
            }
        })
    }
    const handleClose = () => {
        setOpen(false)
        setFileFrente([])
        setFileReverso([])
        setNombreBeneficiario('')
    }
    const handleOpen = () => {
        setOpen(true)
    }
    return (
        <>
            <Tooltip title="Aceptar cotizacion">
                <IconButton aria-label="aceptarCotizacion" onClick={handleOpen}>
                    <BeenhereIcon color="secondary" />
                </IconButton>
            </Tooltip>
            <ModalBase classes={classes} open={open} onClose={handleClose}>
                <HeaderModal handleClose={handleClose} titulo={`Enviar a team leader`} />
                <Grid container className={classes.containerSpacing}>
                    <Box
                        component="form"
                        onSubmit={handleSubmit}
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        gap={2}
                        style={{ width: '500px', margin: 'auto', marginTop: '50px' }}
                    >
                        <label htmlFor="frente">INE Frente</label>
                        <UploadInput
                            files={fileFrente}
                            setFiles={setFileFrente}
                            accept='.jpg,.png,.jpeg'
                            isPreview={false}
                            multiple={false}
                        />
                        <label htmlFor="frente">INE Reverso</label>
                        <UploadInput
                            files={fileReverso}
                            setFiles={setFileReverso}
                            accept='.jpg,.png,.jpeg'
                            isPreview={false}
                            multiple={false}
                        />
                        <TextField
                            label="Nombre del Beneficiario"
                            variant="outlined"
                            fullWidth
                            value={nombreBeneficiario}
                            onChange={handleChange}
                            required
                        />
                        {
                            (false) && <TextField
                                label="Nombre del Beneficiario"
                                variant="outlined"
                                fullWidth
                                value={nombreBeneficiario}
                                onChange={handleChange}
                                required
                            />
                        }
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            fullWidth
                        >
                            Enviar
                        </Button>
                    </Box>
                </Grid>
            </ModalBase>
        </>
    )
}
export default ModalFormAceptarCotizacion